// @flow

import React from "react";

import Section from "../../components/Section";
import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import EditableField from "../../components/EditableField";

import {
  COMPANY__STREET,
  COMPANY__FOUNDING_DATE,
  COMPANY__NAME,
  COMPANY__LOCATION,
  COMPANY__LEGAL_FORM
} from "./formFields";

type OkpCompanyInfoProps = {
  initialValues: {
    [COMPANY__NAME]: string,
    [COMPANY__STREET]: string,
    [COMPANY__FOUNDING_DATE]: string,
    [COMPANY__LOCATION]: string,
    [COMPANY__LEGAL_FORM]: string
  },
  numberedWithDot?: boolean
};

const OkpCompanyInfo = ({ initialValues, numberedWithDot }: OkpCompanyInfoProps) => (
  <Section title="Unternehmensdetails" reducedMargin numberedWithDot={numberedWithDot}>
    <EditableForm initialValues={initialValues} isLocked>
      <FormRow>
        <EditableField
          fieldControlProps={{
            name: COMPANY__NAME,
            caption: () => "Unternehmensname"
          }}
        />

        <EditableField
          fieldControlProps={{
            name: COMPANY__STREET,
            caption: () => "Adressse"
          }}
        />

        <EditableField
          fieldControlProps={{
            name: COMPANY__FOUNDING_DATE,
            caption: () => "Gründungsdatum"
          }}
        />
      </FormRow>

      <FormRow>
        <EditableField
          fieldControlProps={{
            name: COMPANY__LEGAL_FORM,
            caption: () => "Rechtsform"
          }}
        />
        <div />
        <EditableField
          fieldControlProps={{
            name: COMPANY__LOCATION,
            caption: () => "Ort"
          }}
        />

        <div />
        <div />
        <div />
      </FormRow>
    </EditableForm>
  </Section>
);

OkpCompanyInfo.defaultProps = {
  numberedWithDot: false
};

export default OkpCompanyInfo;
